import type { Map as MapLibreMap } from 'maplibre-gl';

/**
 * Стиль карты "control tower".
 *
 * В Фазе 0 подложка временная - публичные векторные тайлы OpenFreeMap.
 * В Фазе 1 она заменяется собственным PMTiles в R2 (инвариант 11: ничего
 * внешнего), и тогда же из CSP уходит строка про tiles.openfreemap.org,
 * а атрибуцию OSM придётся вписать в источник руками: сейчас она приезжает
 * автоматически из TileJSON и исчезнет вместе с ним.
 */
export const TOWER_DARK_STYLE = 'https://tiles.openfreemap.org/styles/dark';

/**
 * Приводит цвета подложки к токенам игры (05 §8): суша panel, вода ink,
 * границы line. Правим уже загруженный стиль, а не пишем свой с нуля -
 * собственный стиль появится вместе с собственными тайлами в Фазе 1.
 */
export function applyTowerColors(map: MapLibreMap): void {
  const INK = '#0b0f14';
  const PANEL = '#0e141c';
  const LINE = '#1c2735';
  const LABEL = '#4a5a6e';

  for (const layer of map.getStyle().layers ?? []) {
    const id = layer.id;
    try {
      if (layer.type === 'background') {
        map.setPaintProperty(id, 'background-color', PANEL);
      } else if (/water|ocean|sea/i.test(id) && layer.type === 'fill') {
        map.setPaintProperty(id, 'fill-color', INK);
      } else if (/boundary|border/i.test(id) && layer.type === 'line') {
        map.setPaintProperty(id, 'line-color', LINE);
      } else if (/landcover|landuse|park|wood|forest/i.test(id)) {
        // Зелень и застройка на диспетчерской карте только мешают читать сеть.
        map.setLayoutProperty(id, 'visibility', 'none');
      } else if (/road|transportation|building|aeroway/i.test(id)) {
        map.setLayoutProperty(id, 'visibility', 'none');
      } else if (layer.type === 'symbol') {
        map.setPaintProperty(id, 'text-color', LABEL);
        map.setPaintProperty(id, 'text-halo-color', INK);
      }
    } catch {
      // Состав слоёв у подложки может измениться: пропущенный слой не повод
      // ронять карту целиком.
    }
  }
}
